import axios from 'axios';

const API_URL = 'https://ead.marcelscur.com/api';;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

export const coursesService = {
  getAll: (params) => api.get('/courses', { params }),
  getBySlug: (slug) => api.get(`/courses/${slug}`),
  getEnrolled: () => api.get('/courses/my/enrolled'),
};

export const progressService = {
  markComplete: (lessonId) => api.post('/progress/complete', { lesson_id: lessonId }),
};

export const enrollmentsService = {
  enrollFree: (courseId) => api.post('/enrollments/free', { course_id: courseId }),
};

export const certificatesService = {
  generate: (courseId) => api.post('/certificates/generate', { course_id: courseId }),
  getMy: () => api.get('/certificates/my'),
};

export default api;
